module.exports = __webpack_public_path__ + "static/media/Isteelsection.1948a9e9.svg";